/**
 * Global state to track if an advertising modal is currently open
 * Prevents multiple modals from opening simultaneously
 */

let isAdvertisingModalOpen = false

export const getAdvertisingModalOpenState = (): boolean => {
  return isAdvertisingModalOpen
}

export const setAdvertisingModalOpenState = (isOpen: boolean): void => {
  isAdvertisingModalOpen = isOpen
}
